oldVariables